"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.m = void 0;
var tslib_1 = require("tslib");
var hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
exports.m = hyperscript_1.default;
//# sourceMappingURL=mithril.js.map